import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function HowItWorksSection() {
  const ref = useScrollReveal();
  return <section ref={ref} className="w-full section-padding" style={{
    backgroundColor: '#1a2744'
  }} aria-label="How it works" data-id="element-176">
      <div className="max-w-3xl mx-auto text-center" data-id="element-177">
        {/* Label */}
        <div className="scroll-reveal mb-8" data-id="element-178">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase px-3 py-1.5 rounded-full border" style={{
          color: '#c9a96e',
          borderColor: 'rgba(201,169,110,0.4)',
          backgroundColor: 'rgba(201,169,110,0.08)',
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-179">
            The Process
          </span>
        </div>

        {/* Heading */}
        <div className="scroll-reveal scroll-reveal-delay-1 mb-4" data-id="element-180">
          <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-181">
            Three Steps. Seventy-Two Hours.{' '}
            <span className="italic" style={{
            color: '#c9a96e'
          }} data-id="element-182">
              Permanent Results.
            </span>
          </h2>
        </div>

        <div className="scroll-reveal scroll-reveal-delay-2 gold-divider mb-12" data-id="element-183" />

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-left" data-id="element-184">
          <div className="scroll-reveal scroll-reveal-delay-2 flex flex-col items-start gap-4" data-id="element-185">
            <div className="w-12 h-12 rounded-full flex items-center justify-center text-xl font-bold flex-shrink-0" style={{
            backgroundColor: '#c9a96e',
            color: '#1a2744',
            fontFamily: "'Playfair Display', serif"
          }} aria-hidden="true" data-id="element-186">
              1
            </div>
            <div data-id="element-187">
              <h3 className="text-xl font-bold text-white mb-2" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-188">
                Audit the Room
              </h3>
              <p className="text-sm leading-relaxed" style={{
              color: '#a09890',
              fontFamily: "'Inter', sans-serif"
            }} data-id="element-189">
                Use the Biological Alarm list to identify and fix every
                environmental factor sabotaging sleep — starting tonight.
              </p>
            </div>
          </div>

          <div className="scroll-reveal scroll-reveal-delay-3 flex flex-col items-start gap-4" data-id="element-190">
            <div className="w-12 h-12 rounded-full flex items-center justify-center text-xl font-bold flex-shrink-0" style={{
            backgroundColor: '#c9a96e',
            color: '#1a2744',
            fontFamily: "'Playfair Display', serif"
          }} aria-hidden="true" data-id="element-191">
              2
            </div>
            <div data-id="element-192">
              <h3 className="text-xl font-bold text-white mb-2" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-193">
                Set the Anchors
              </h3>
              <p className="text-sm leading-relaxed" style={{
              color: '#a09890',
              fontFamily: "'Inter', sans-serif"
            }} data-id="element-194">
                Follow the 7-step light and meal timing chart to trigger natural
                melatonin production at exactly 7:30 PM.
              </p>
            </div>
          </div>

          <div className="scroll-reveal scroll-reveal-delay-4 flex flex-col items-start gap-4" data-id="element-195">
            <div className="w-12 h-12 rounded-full flex items-center justify-center text-xl font-bold flex-shrink-0" style={{
            backgroundColor: '#c9a96e',
            color: '#1a2744',
            fontFamily: "'Playfair Display', serif"
          }} aria-hidden="true" data-id="element-196">
              3
            </div>
            <div data-id="element-197">
              <h3 className="text-xl font-bold text-white mb-2" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-198">
                Hold the Boundary
              </h3>
              <p className="text-sm leading-relaxed" style={{
              color: '#a09890',
              fontFamily: "'Inter', sans-serif"
            }} data-id="element-199">
                Use the "Quiet Return" for 72 hours to permanently end the
                "Jackpot" cycle — no screaming required.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}